import { str2time } from '@/util/format/duration'

const intersect = (d , a) => {
  let c = a.map(str2time)
  console.log(c , d)
  for(let i of d){
    let b = i.map(str2time)
    if( (c[0] <= b[1] && c[0] >= b[0]) || (c[1] <= b[1] && c[1] >= b[0]) ){
      return true 
    }
  }
  return false
}

export default {
  props:['value'],
  data(){
    return {
      data:[],
      createOpen:false,
      currentEditIdx:-1
    }
  },
  created(){
    this.$watch('value' , function(nv){
      if(nv){
        this.data = nv
      }
    },{immediate:true})


  },
  methods:{
    handleAdd(v){
      this.data.push(v)
      this.emit()
    },
    handleRemove(idx){
      this.data.splice(idx , 1)
      this.emit()
    },
    handleChange(v , idx){
      const data = [...this.data]
      data[idx] = v
      this.data = data
      this.emit()
    },
    handleEdit(idx){
      this.currentEditIdx = idx
    },
    check(nv , idx = -1){
      console.log('>>>>',nv)

      if(idx == -1){
        if(intersect(this.data , nv)){
          this.$Message.error('不能与已有时段重复')
          return false
        }
      }else{
        let d = [...this.data]
        d.splice(idx,1)
        if(intersect(d , nv)){
          this.$Message.error('不能与已有时段重复')
          return false
        }
      }
    },
    emit(){
      let publicData = this.data.map(i => [...i])
      this.$emit('change' , publicData)
      this.$emit('input' , publicData)
    },
    //<TimePicker confirm value={item} type="timerange" placeholder="请选择时段" on-on-change={(d) => this.handleChange(idx , d)} ></TimePicker>
    renderItem(item , idx){
      return (
        <div style="padding-bottom:8px">
          <sl-time-range-picker value={item} steps={[1, 30, 60]} on-change={(v) => this.handleChange(v , idx)} filter={(v) => this.check(v , idx)} >
            {item[0]} - {item[1]}
          </sl-time-range-picker>
          <Icon type="md-trash" size={18} style="margin-left:8px;" on-click={() => this.handleRemove(idx)} />
        </div>
      )
    }
  },
  render(){
    const { renderItem , handleAdd } = this
    return (
      <div>
        { this.data.map( renderItem ) }
        <sl-time-range-picker steps={[1, 30, 60]} on-change={handleAdd} filter={(v) => this.check(v)} >
          <a>添加时段</a>
        </sl-time-range-picker>
      </div>
    )
  }
}